import React from "react";
import dynamic from "next/dynamic";
import { DESKTOP_WIDTH } from "@/constants";
import { useMediaQuery } from "react-responsive";

const MediaQuery = dynamic(() => import("react-responsive"), {
  ssr: false,
});

export const useMobileMediaQuery = () =>
  useMediaQuery({ query: `(max-width: ${DESKTOP_WIDTH - 1}px)` });

const MobileContainer = ({ children }) => {
  return <MediaQuery maxWidth={DESKTOP_WIDTH - 1}>{children}</MediaQuery>;
};

export default MobileContainer;
